import raw from "../../../../content/noutati.json";
import type { LandingImageKey } from "../components/landing/landingImages";

/**
 * Conținutul secțiunii Noutăți.
 *
 * Sursa e un JSON la rădăcina proiectului, ca să poată fi citit și de scriptul
 * de prerenderare (scripts/build-static-pages.mjs), care rulează în Node și nu
 * poate importa module TypeScript. Un singur fișier, două consumatoare.
 */

export type ArticleBlock =
  | { type: "p"; text: string }
  | { type: "h2"; text: string }
  | { type: "quote"; text: string }
  | { type: "ul"; items: string[] }
  | { type: "ol"; items: string[] };

export type Article = {
  slug: string;
  title: string;
  description: string;
  /** ISO, YYYY-MM-DD */
  publishedAt: string;
  readMinutes: number;
  image: LandingImageKey;
  blocks: ArticleBlock[];
};

export const articles = (raw.articles as Article[])
  .slice()
  // Cele mai recente primele
  .sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));

export function findArticle(slug: string): Article | undefined {
  return articles.find((article) => article.slug === slug);
}

export function formatArticleDate(iso: string): string {
  // Ziua e fixă în string, deci construim data în UTC ca să nu alunece
  // cu o zi în funcție de fusul orar al vizitatorului.
  return new Date(`${iso}T12:00:00Z`).toLocaleDateString("ro-RO", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
